import { render, staticRenderFns } from "./BaseAudioPlayer.vue?vue&type=template&id=7252b35a&scoped=true&"
import script from "./BaseAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./BaseAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BaseAudioPlayer.vue?vue&type=style&index=0&id=7252b35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252b35a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7252b35a')) {
      api.createRecord('7252b35a', component.options)
    } else {
      api.reload('7252b35a', component.options)
    }
    module.hot.accept("./BaseAudioPlayer.vue?vue&type=template&id=7252b35a&scoped=true&", function () {
      api.rerender('7252b35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseAudioPlayer.vue"
export default component.exports